    var $ = window.jQuery;

    $(function() {
      //导航栏颜色
      $('#header ul li:eq(5) a').attr('class','activity');

      $(".history-line:eq(0)").mousedown(function(e){
				e.preventDefault();
			});
    	//  superSlide
			$(".company-honor-pic").slide({mainCell:".bd ul",autoPlay:true,effect:"leftMarquee",vis:3,interTime:50});

			// 视察滚动
			$(window).scroll(function() {
				var top = 0;
				top = $(this).scrollTop();
				if (top < 1600) {
					$(".scroll-pic").css("top", top + "px");
				}
			});
    });
